import * as d3 from "d3"

export const computeFromAttributes = () => {
  d3.select("#svg-dashboard")
    .selectAll("g.playerdash-dashboard-button")
    .datum(function () {
      const buttonElement = d3.select(this)
      return {
        x: Number(buttonElement.attr("x")),
        y: Number(buttonElement.attr("y")),
        width: Number(buttonElement.attr("width")),
        height: Number(buttonElement.attr("height")),
        uuid: buttonElement.attr("uuid"),
      }
    })
}
